import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Link } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Header from '../../components/Header'
import MissingTranslations from '../../components/MissingTranslations'
import Page from '../../components/Page'
import Sorter, { SortControl } from '../../components/Sorter'
import StickyTable from '../../components/StickyTable'
import { MAIN_LANG } from '../../consts'
import { useQsFilters } from '../../hooks/filters'
import { BlockHome } from '../../types'
import { useBlocksHome, useDeleteBlockHome } from '../../hooks/blocks-home'

const initFilters = (params: URLSearchParams) => ({
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? '',
})

const MISSING_TRANSLATIONS_FIELDS = ['title']

export default function BlocksHomePageList() {
  const { filters, uiFilters, setFiltersDebounced, setFilters } =
    useQsFilters(initFilters)
  const { data } = useBlocksHome(filters)
  const deleteBlock = useDeleteBlockHome()
  const [modalRm, modalRmActions] = useModalTrigger<BlockHome>()

  return (
    <Page padded>
      <Header>
        <div className="d-flex align-items-end">
          <h2 className="m-0">Blocchi Home Page</h2>
          <div className="counter ms-2 mb-1"></div>
        </div>
        <Link className="btn btn-primary" to="/blocks-home-page/new">
          <i className="bi bi-plus-circle me-2"></i> Aggiungi
        </Link>
      </Header>
      <div className="d-flex justify-content-between mt-3 mb-3 align-items-center">
        <input
          placeholder="Cerca"
          className="form-control w-auto"
          type="text"
          value={uiFilters.search}
          onChange={(e) => setFiltersDebounced({ search: e.target.value })}
        />
      </div>
      <StickyTable className="flex-1">
        <thead>
          <Sorter
            value={uiFilters.ordering}
            onSortChange={(ordering) =>
              setFilters({
                ordering,
              })
            }
          >
            <tr>
              <th>#</th>
              <th>
                <div className="d-flex align-items-center">
                  Titolo
                  <SortControl field={`title__${MAIN_LANG}`} />
                </div>
              </th>
              <th>Ordine</th>
              <th></th>
            </tr>
          </Sorter>
        </thead>
        <tbody>
          {data!.map((block) => (
            <tr key={block.id}>
              <td>{block.id}</td>
              <td>
                <Link to={`/blocks-home-page/${block.id}`}>
                  {block.title[MAIN_LANG]}
                </Link>
                <MissingTranslations
                  data={block}
                  fields={MISSING_TRANSLATIONS_FIELDS}
                />
              </td>
              <td>
                {block.order}
              </td>
              <td>
                <i
                  onClick={() => modalRmActions.open(block)}
                  className="bi cursor-pointer text-danger bi-trash3-fill"
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </StickyTable>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il blocco home page{' '}
              {modalRm.value.title[MAIN_LANG]} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteBlock.isLoading}
            onClick={async () => {
              await deleteBlock.mutateAsync(modalRm.value!.id)
              modalRmActions.close()
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
